import React, { useEffect, useRef } from "react";
import { axiosGet } from "../../util/axios";
import { useDispatch, useSelector } from "react-redux";
import { IRootState, IRootThunkDispatch } from "../../redux/store";
import {
  changePageThunk,
  changePageWithDetailThunk,
  initTopNavBarThunk,
} from "../../redux/common/navBar/thunkl";
import { Grid, Popover, Typography } from "@mui/material";
import styles from "./TopNav.module.css";

function TopNav() {
  const dispatch = useDispatch<IRootThunkDispatch>();
  const { navList, page } = useSelector(
    (state: IRootState) => state.initNavBarState
  );
  const [HoveredNav, setHoveredNav] = React.useState<number | null>(null);
  const dataFetchedRef = useRef(false);

  useEffect(() => {
    const controller = new AbortController();
    if (dataFetchedRef.current) return;
    dataFetchedRef.current = true;
    getNavBar();
    return () => {
      controller.abort();
    };
  }, [dispatch]);

  async function getNavBar() {
    const result = await axiosGet("/api/common/topNav");
    if (result.data.success) {
      dispatch(initTopNavBarThunk(result.data.navList));
    }
  }

  function handleChangeNav(navBar_id: number,index:number,detailPage?:string) {
    if (detailPage){
        dispatch(changePageWithDetailThunk(navBar_id,index,detailPage))       
        return
    }
    dispatch(changePageThunk(navBar_id,index));
    
  }

  return (
    <>
      <Grid className={styles.TopNavOuterContainer}>
        {navList ? (
          navList.map((list, index) => (
            <Grid
              key={`list.navBar_id-${list.navBar_id}`}
              className={`${styles.TopNavContainer} ${
                list.navBar_id === page ? styles.ClickedNavigation : ""
              }`}
              onMouseEnter={() => setHoveredNav(list.navBar_id)}
              onMouseLeave={() => setHoveredNav(null)}
              onClick={() => handleChangeNav(list.navBar_id!,index)}
            >
              <Grid key={`nav-${index}`}>{list.name}</Grid>

              {HoveredNav === list.navBar_id && list.nav_bar_detail ? (
                <Grid className={styles.DropdownContainer}>
                  {list.nav_bar_detail.split(",").map((detail, detailIndex) => (
                    <Grid
                      key={`detail-${detailIndex}`}
                      className={styles.DropdownItem}
                      onClick={() => handleChangeNav(list.navBar_id!,index,detail)}
                    >
                      {detail}
                    </Grid>
                  ))}
                </Grid>
              ) : null}
            </Grid>
          ))
        ) : (
          <></>
        )}
      </Grid>
    </>
  );
}

export default TopNav;
